import { Component, Input, OnInit } from '@angular/core';
import GuestAccessStatusTagView from './guest-access-status-tag.component.html';
@Component({
  selector: 'guest-access-status-tag',
  template: GuestAccessStatusTagView,
  styles: ':host { color: white; }'
})
export class GuestAccessStatusTagComponent implements OnInit {
  @Input() status: string;

  statusColors: string[] = ['#ed5565', '#23c6c8', '#f8ac59'];

  constructor() { }

  ngOnInit() {
  }
}
